import { FormType, Properties, BlurProperties } from "../properties.model";
import { EffectsType } from "../ui-effects.model";

export const blurForm: Properties = {
  propertyType: EffectsType.Blur,
  label: 'Blur',
  forms: [
  {
    id: BlurProperties.BlurStrength,
    label: 'Blur Strength',
    type: FormType.SliderNumber,
    sliderOptions: {
      min: 0,
      max: 10,
      step: 0.01
    }
  },
  ],
  changeHandler: () => {}
}
